/**
 * Ajuda dos campos dos modelos de documento e de mensagem.
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6.
 */
export const ajuda: Record<string, Record<string, string>> = {
  '/templates': {
    Tipo: 'Define onde o modelo e usado e quais variaveis aceita. O de apolice gera o documento na emissao, pelo vinculo da aba Vinculos. O laudo de emissao sai do modelo deste tipo em Word publicado por ultimo; sem ele, do neutro do sistema.',
    Formato:
      'Texto escrito aqui serve a e-mail e mensagem. Documento do Word serve a minuta, CCG, apolice e laudo: margem, cabecalho, tabela e imagem vem do arquivo, e o gerado sai em Word e em PDF.',
    // Vinculos do documento da apolice (P-MIN-2).
    'Modelo de apolice':
      'Modelo do tipo apolice, em Word, que gera o documento da apolice. O texto e da seguradora: e carregado aqui, e nunca fica no codigo da plataforma.',
    'Seguradora do vinculo':
      'Vazio vale para todas as seguradoras. Com a seguradora, o vinculo pesa mais na escolha: o documento e dela, com a marca e o rodape dela.',
    'Produto do vinculo': 'Vazio vale para todos os produtos.',
    'Grupo de modalidade':
      'Grupo do ramo, como Judicial ou Tradicional. Informe o grupo ou a modalidade, nao os dois: a modalidade ja diz o grupo.',
    'Modalidade do vinculo':
      'Vazio vale para todas as modalidades do produto. A modalidade pesa mais que o grupo e o produto na escolha.',
    Movimento:
      'Movimento da apolice que o documento registra. So a emissao gera documento hoje; endosso e cancelamento sao do pacote do endosso.',
    'Observacao da prova':
      'O que foi conferido no documento de prova, como o numero do parecer juridico. Reprovar exige o motivo.',
    'Codigo SUSEP do corretor na emissao':
      'Avisar e emitir: o documento sai sem o codigo, com aviso. Recusar e regra sem fonte aprovada (decisao 12 da 11.12): so a empresa liga.',
  },
};
